module.exports = __webpack_public_path__ + "img/sb02-07.f0822a09.png";